module.exports = __webpack_public_path__ + "img/avetar.142bfcda.4d8e152e.png";